<template>
    <div
        class="m-summary m-summary--checkout a-mobile"
        :class="{'m-summary--fixed': fixed}"
    >
        <div class="m-summary__wrapper">
            <div class="a-title">
                Kwota zamówienia
            </div>
            <p class="m-summary__title">Łączny koszt dostaw*:</p>
            <p class="a-price m-summary__price"><span class="a-price__price">{{ totalAmount }}</span> <span class="a-price__time">/ 7 dni</span></p>
            <p class="a-price m-summary__price">{{ totalAmountMonth }} <span class="a-price__time">/ 1 mc</span></p>
            <p class="m-summary__text">Ceny netto, VAT w zależności od produktu <strong>5%</strong> lub <strong>8%.</strong></p>
            <hr class="a-hr m-summary__hr" />
            <p class="m-summary__description">
                Średni całkowity koszt miesięczny produktów łącznie z dostawą do kuchni w godzinach <strong>08:00 - 12:00.</strong>
                W cenie zawarte jest wymienne <strong>opakowanie drewniane</strong> lub <strong>kartonowe</strong>.
            </p>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            fixed: false
        }
    },
    computed: {
        totalAmount() {
            return this.$store.getters.offerTotalAmount.toFixed(2).toPLN()
        },
        totalAmountMonth() {
            return this.$store.getters.offerTotalAmountMonth.toFixed(2).toPLN()
        }
    },
    methods: {
        handleScroll(event) {
            this.fixed = window.scrollY > 199
        }
    },
    created () {
        if(this.$route.name === 'checkout') {
            window.addEventListener('scroll', this.handleScroll)
        }
    },
    destroyed () {
        if(this.$route.name === 'checkout') {
            window.removeEventListener('scroll', this.handleScroll)
        }
    }
}
</script>
